


















































































import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Currency from '@/domain/currency/entity/currency.entity';
import CurrencyService from '@/domain/currency/service/currency.service';
import ContractItem from '@/domain/contract/entity/contract-item.entity';
import ContractItemUpdateExchangeConfigurationRequest from '@/domain/contract/request/contract-item-exchange-config-update.request';
import ContractService from '@/domain/contract/service/contract.service';
import ContractItemExchange from '@/domain/contract/entity/contract-item-exchange.entity';

@Component({
  components: {
    MainButton,
    LabelSlot,
    VbTooltipSlot,
  },
})
export default class ExchangeConfigurationModal extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  contractItem!: ContractItem;

  loading: boolean = false;

  currencies: Currency[] = [];

  brlCurrencyLoaded: boolean = false;

  brlCurrency?: Currency;

  exchangeConfiguration = ContractItemExchange.of({});

  created() {
    this.getCurrencies();
  }

  @Watch('contractItem.exchange')
  applyInitialConfiguration() {
    if (this.contractItem.exchange) {
      this.exchangeConfiguration = this.contractItem.exchange;
    } else {
      this.exchangeConfiguration = ContractItemExchange.of({});
    }
  }

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  get configSaveDisabled() {
    if (this.contractItem.exchange.convertFrom.id !== '') {
      return this.contractItem.exchange.convertTo.id === '' || this.loading;
    }
    if (this.contractItem.exchange.convertTo.id !== '') {
      return this.contractItem.exchange.convertFrom.id === '' || this.loading;
    }
    return this.loading;
  }

  updateExchange() {
    this.loading = true;
    ContractService.updateItemExchangeConfiguration(
      this.businessUnitId, this.contractItem.id, ContractItemUpdateExchangeConfigurationRequest.of(
        this.exchangeConfiguration.convertFrom.id,
      ),
    )
      .then(() => {
        VbSnackbarService.showSuccess('Configuração de conversão salva com sucesso');
        this.$emit('updateConfigSuccess')
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => this.loading = false);
  }

  startLoading(): void {
    this.loading = true;
  }

  clearConfiguration() {
    this.contractItem.clearExchangeConfiguration();
  }

  stopLoading(): void {
    this.loading = false;
  }

  getCurrencies() {
    CurrencyService.getAllCurrencies()
      .then((resp: any) => {
        this.currencies = Currency.ofList(resp);
        this.brlCurrency = this.currencies.find((it) => it.name === 'BRL');
        this.brlCurrencyLoaded = true;
      });
  }
}
